import React from 'react';

export const CalendarSkeleton: React.FC = () => {
  const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const skeletonCells = Array.from({ length: 42 }); // Assuming 6 weeks for month view

  return (
    <div className="mt-6 animate-pulse">
      {/* Header row skeleton */}
      <div className="grid grid-cols-7 text-center text-xs font-semibold leading-6 text-gray-400 dark:text-dark-tremor-content border-b border-gray-200 dark:border-dark-tremor-border pb-2 mb-2">
        {daysOfWeek.map((day) => (
          <div key={day} className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2 mx-auto"></div>
        ))}
      </div>

      {/* Grid cells skeleton */}
      <div className="grid grid-cols-7 gap-px border border-gray-100 dark:border-dark-tremor-border bg-gray-100 dark:bg-dark-tremor-border overflow-hidden rounded-lg shadow">
        {skeletonCells.map((_, index) => (
          <div
            key={index}
            className="relative min-h-[120px] bg-white dark:bg-dark-tremor-background p-2" // Mimic cell background and padding
          >
             <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/4 mb-2"></div> {/* Placeholder for date number */}
             <div className="space-y-1 mt-1">
                <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-3/4"></div> {/* Placeholder for shift */}
                <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-1/2"></div> {/* Placeholder for another shift */}
             </div>
          </div>
        ))}
      </div>
    </div>
  );
}; 